import React from "react";
import SideBar from "../../../common/SideBar";
import HeaderBar from "../../../common/HeaderBar";
import TeacherResources from "./TeacherResources"; 

const TeacherMainPage = () => {
  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content inner-page-content--aira-chat">
        <SideBar />
        <TeacherResources />
      </div>
    </main>
  );
};

export default TeacherMainPage;
